// Third Party Imports
import React from 'react';

// Relative Imports
import ConfirmBrandButton from '../Button/ConfirmBrandButton';
import './ConfirmBrandButtonHolder.less';
import { getCurrencySymbol } from '../../utils/constants';

export default class ConfirmBrandButtonHolder extends React.Component {
    constructor(props) {
        super(props);
    }

    displayCurrencyList(currencyList) {
        if (!currencyList || currencyList.length === 0) {
            return (<span key={null} />);
        }
        return currencyList.map((currency, index) => (
            <span key={currency}>
                {currency} {getCurrencySymbol(currency) || ''}{index < currencyList.length - 1 && <span>{' or '}</span>}
            </span>
        ));
    }

    renderConfirmBrandButton() {
        const {
            translations,
            enableContinueButton,
            handleConfirmBrandButtonClick,
            continueButtonId,
            data,
            brandImage,
            flagImage,
            isSingleBrandPPMtoIPM,
            languageCurrencyMismatch
        } = this.props;

        return (
            <ConfirmBrandButton
                translations={translations}
                brandImage={brandImage}
                flagImage={flagImage}
                language={data.locale}
                domain={data.domain}
                currencies={this.displayCurrencyList(data.currencies)}
                supportedCurrencyCount={data.currencies?.length}
                confirmBrand={handleConfirmBrandButtonClick}
                buttonId={continueButtonId}
                enableButton={enableContinueButton}
                isSingleBrandPPMtoIPM={isSingleBrandPPMtoIPM}
                languageCurrencyMismatch={languageCurrencyMismatch}
            />
        )
    }

    render() {
        const {
            data,
            isSingleBrandPPMtoIPM
        } = this.props;

        const isSingleBrandMultiCurrency = isSingleBrandPPMtoIPM && data && data.currencies && data.currencies.length > 1;

        return (
            <div className={`confirm-brand-continue-button-holder ${isSingleBrandMultiCurrency ? 'single-brand-multi-currency' : ''}`}>
                {this.renderConfirmBrandButton()}
            </div>
        );
    }
}
